// extracted by mini-css-extract-plugin
module.exports = {"cpEditBuildingButtonSection":"EditBuildingSummary_cpEditBuildingButtonSection__2Z5kD","cpEditBuildingSaveButton":"EditBuildingSummary_cpEditBuildingSaveButton__2EGBr"};